import { Component } from '@angular/core';

@Component({
  selector: 'app-not-found.component',
  imports: [],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
  standalone: true,
})
export class NotFoundComponent {}
